import { render, staticRenderFns } from "./OpenForestRedeem.vue?vue&type=template&id=9a6843e0&"
import script from "./OpenForestRedeem.vue?vue&type=script&lang=ts&"
export * from "./OpenForestRedeem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports